<template>
  <div>
    <div class="espacio"></div>

    <!-- Encabezado -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div v-if="mensajeDetalle"
               class="form-control is-invalid d-inline-block"
               style="width:auto">
            {{ mensajeDetalle }}
          </div>
        </div>
      </div>
    </div>

<Modal v-model:modelValue="showModalHelp" title="Ayuda — Diagnósticos">
  <AyudaDiagAten />
</Modal>

    <!--  DataTable  -->
    <DataTable
      :data="diagatens"
      :columns="columnas"
      idField="idDiagAten"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="estadoPermitido"
      mensajeVacio="No hay diagnósticos registrados."
      @refresh="cargarDatos()"
      @create="abrirModalCrear"
      @edit="({ idDiagAten }) => abrirModalEditar(idDiagAten)"
      @delete="({ idDiagAten }) => deleteDiagAten(idDiagAten)"
    >
      <!-- Celda: Tipo decodificado -->
      <template #cell-tipo="{ row }">
        {{ valorTipoDiag(row.tipo) }}
      </template>

      <!-- Celda: Nombre + estado -->
      <template #cell-diagnosticoNombre="{ row }">
        {{ row.diagnosticoNombre }} — {{ row.estado }}
      </template>

      <!-- Botón de ayuda -->
      <template #boton-ayuda>
        <button
          class="btn-help"
          type="button"
          title="Abrir ayuda de diagnósticos"
          @click="showModalHelp = true"
          aria-label="Abrir ayuda de diagnósticos"
        >
          <span class="material-symbols-outlined">help</span>
        </button>
      </template>
    </DataTable>

    <!--  Modal crear / editar  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalDiagAtenLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalDiagAtenLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- Buscador LOV de diagnósticos -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Diagnóstico</label>
                </div>
                <div class="col-10">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           v-model="searchTextDiag"
                           @input="filterDiagnosticos()"
                           @keyup.enter="toggleDropdown()"
                           placeholder="Buscar diagnóstico...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            ref="dropdownButton">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height:250px;overflow-y:auto;width:100%"
                        ref="dropdownMenu">
                      <li v-for="diag in filteredDiagnosticos"
                          :key="diag.idDiagnostico">
                        <a class="dropdown-item text-truncate"
                           href="#"
                           @click.prevent="selectDiagnostico(diag)"
                           :title="diag.nombre">
                          {{ diag.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Tipo -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-2">
                  <label class="form-label">Tipo</label>
                </div>
                <div class="col-10">
                  <select class="form-select" v-model="datoDiagAten.tipo">
                    <option value="" disabled>Seleccione una opción</option>
                    <option value="P">Presuntivo</option>
                    <option value="D">Definitivo</option>
                  </select>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarDiagAten()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar" type="button"
                    class="btn btn-success"
                    @click.prevent="guardarEditDiagAten()">
              <span class="material-symbols-outlined align-middle"
                    style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AyudaDiagAten       from '@/views/ayuda/AyudaDiagAten.vue'
import DataTable           from '@/components/DataTable.vue'
import { validarForm }     from '@/modules/validacionesForms.js'
import { decodificarTipoDiag } from '@/modules/decode.js'
import api                 from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal                from 'sweetalert'

export default {
  name: 'DiagAten',

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
  },

  components: { AyudaDiagAten, DataTable },

  data() {
    return {
      diagatens:            [],
      datoDiagAten:         {},
      titulo:               '',
      btnCrear:             false,
      btnEditar:            false,
      modalWindow:          true,
      diagnosticos:         [],
      filteredDiagnosticos: [],
      searchTextDiag:       '',
      mensajeDetalle:       '',
      showModalHelp:        false,

      columnas: [
        { field: 'tipo',               label: 'Tipo' },
        { field: 'diagnosticoCodigo',  label: 'Código' },
        { field: 'diagnosticoNombre',  label: 'Nombre' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  mounted() {
    this.cargarDatos()
    this.fetchDiagnosticos()
  },

  methods: {
    valorTipoDiag(codigo) {
      return decodificarTipoDiag(codigo)
    },

    //  Carga de datos
    cargarDatos() {
      api.get(`/vwdiagatens/idatencion/${this.p_idAtencion}`)
        .then(response => { this.diagatens = response.data.reverse() })
        .catch(error   => console.error('Error cargando diagnósticos:', error))
    },

    fetchDiagnosticos() {
      api.get('/vwdiagnosticos')
        .then(response => {
          this.diagnosticos         = response.data
          this.filteredDiagnosticos = response.data
        })
        .catch(error => console.error('Error fetching diagnósticos:', error))
    },

    //  LOV de diagnósticos
    filterDiagnosticos() {
      const q = this.searchTextDiag.toLowerCase()
      this.filteredDiagnosticos = q
        ? this.diagnosticos.filter(d => d.nombre.toLowerCase().includes(q))
        : this.diagnosticos
    },

    selectDiagnostico(diag) {
      this.datoDiagAten.idDiagnostico = diag.idDiagnostico
      this.searchTextDiag             = diag.nombre
    },

    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoDiagAten,
        ['idDiagnostico', 'tipo'],
        ['idDiagnostico', 'tipo']
      )
    },

    //  CRUD
    async guardarDiagAten() {
      if (this.validarForm() !== 1) return
      try {
        this.datoDiagAten.idAtencion = this.p_idAtencion
        await api.post('/diagatens', this.datoDiagAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Diagnóstico creado exitosamente!', 'success')
        this.cargarDatos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async guardarEditDiagAten() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/diagatens', this.datoDiagAten)
        closeModal('ventanaModal')
        swal('Correcto!', 'Diagnóstico actualizado exitosamente!', 'success')
        this.cargarDatos()
      } catch {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
      }
    },

    async deleteDiagAten(idDiagAten) {
      if (!this.estadoPermitido) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }
      try {
        await api.delete(`/diagatens/${idDiagAten}`)
        this.cargarDatos()
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error')
      }
    },

    //  Apertura de modal
    abrirModalCrear() {
      this.modalWindow    = true
      this.datoDiagAten   = {}
      this.searchTextDiag = ''
      this.titulo         = 'Diagnósticos'
      this.btnCrear       = true
      this.btnEditar      = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idDiagAten) {
      if (!this.estadoPermitido) {
        this.mensajeDetalle = `La acción no está permitida porque el estado es ${this.p_estadoAtencion}.`
        return
      }
      this.modalWindow = true
      if (idDiagAten) {
        api.get(`/vwdiagatens/${idDiagAten}`).then(resp => {
          this.datoDiagAten   = resp.data
          this.searchTextDiag = `${resp.data.diagnosticoCodigo} - ${resp.data.diagnosticoNombre}`
        })
      }
      this.titulo    = 'Diagnósticos'
      this.btnCrear  = false
      this.btnEditar = true
      openModal('ventanaModal')
    },
  },
}
</script>

<style src="@/assets/css/listaFiltrada02.css" scoped></style>
<style src="@/assets/css/tabla_estilizada.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.espacio { margin-top: 0.25em; }
</style>